import { useEmitter } from '@/composables/core'

function getNuxtEmitter(proxy) {
	if (proxy?.$nuxt) {
		return proxy.$nuxt
	}

	if (typeof window !== 'undefined' && window.$nuxt) {
		return window.$nuxt
	}

	return null
}

export function createNavbarEmitter(proxy) {
	const emitter = useEmitter()
	const nuxt = getNuxtEmitter(proxy)

	return {
		emit(event, ...payload) {
			emitter.emit(event, ...payload)
			nuxt?.$emit?.(event, ...payload)
		},
		on(event, handler) {
			emitter.on(event, handler)
			nuxt?.$on?.(event, handler)
		},
		off(event, handler) {
			emitter.off(event, handler)
			nuxt?.$off?.(event, handler)
		},
	}
}
